import React from 'react';
import { motion } from 'framer-motion';
export function FinalCTA() {
  return <section className="py-24 lg:py-32 px-4 sm:px-6 lg:px-8 bg-navy-deep text-center" data-id="element-583">
      <div className="max-w-4xl mx-auto" data-id="element-584">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-585">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-white mb-6 leading-tight" data-id="element-586">
            Build more capable people. <br className="hidden md:block" data-id="element-587" />
            Stronger institutions. Better leadership.
          </h2>

          <p className="text-lg text-surface-muted/80 mb-10 max-w-2xl mx-auto leading-relaxed" data-id="element-588">
            SyNeural's CJI and NCJI platforms are designed to help individuals
            develop, institutions strengthen, communities stabilize, and
            leadership become more competent over time.
          </p>

          <div className="flex flex-col sm:flex-row justify-center gap-4" data-id="element-589">
            <button className="bg-white text-navy font-bold px-8 py-4 rounded-md hover:bg-surface-muted transition-colors shadow-lg" data-id="element-590">
              Request a Demo
            </button>
            <button className="bg-transparent border border-white/30 text-white font-medium px-8 py-4 rounded-md hover:bg-white/10 transition-colors" data-id="element-591">
              Start a Partnership Conversation
            </button>
          </div>
        </motion.div>
      </div>
    </section>;
}